import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { firestore, doc, setDoc, getDoc, addDoc, collection, getAuth, signInAnonymously } from './plugins/firebase'

Vue.config.productionTip = false

Vue.use(BootstrapVue)

const auth = getAuth();
signInAnonymously(auth)
  .then((user) => {
    console.log(user);
    new Vue({
      render: h => h(App),
      beforeCreate() {
        Vue.prototype.$firestore = firestore;
        Vue.prototype.$doc = doc;
        Vue.prototype.$setDoc = setDoc;
        Vue.prototype.$getDoc = getDoc;
        Vue.prototype.$addDoc = addDoc;
        Vue.prototype.$collection = collection;
      }
    }).$mount('#app')
  })
  .catch((error) => {
    console.error(error)
  });